import { render, staticRenderFns } from "./kabWin.vue?vue&type=template&id=3a9d08cc&scoped=true&"
import script from "./kabWin.vue?vue&type=script&lang=js&"
export * from "./kabWin.vue?vue&type=script&lang=js&"
import style0 from "./kabWin.vue?vue&type=style&index=0&id=3a9d08cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9d08cc",
  null
  
)

export default component.exports